import { CreateDecryptedItemFromPayload, DecryptedPayload, FillItemContentSpecialized, PayloadTimestampDefaults, ProtocolVersion, } from '@standardnotes/models';
import { V004Algorithm } from '../../../../Algorithm';
import { ContentType } from '@standardnotes/domain-core';
export class CreateKeySystemItemsKeyUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(dto) {
        const key = this.crypto.generateRandomKey(V004Algorithm.EncryptionKeyLength);
        const content = FillItemContentSpecialized({
            itemsKey: key,
            creationTimestamp: new Date().getTime(),
            version: ProtocolVersion.V004,
            rootKeyToken: dto.rootKeyToken,
        });
        const transferPayload = {
            uuid: dto.uuid,
            content_type: ContentType.TYPES.KeySystemItemsKey,
            key_system_identifier: dto.keySystemIdentifier,
            shared_vault_uuid: dto.sharedVaultUuid,
            content: content,
            dirty: true,
            ...PayloadTimestampDefaults(),
        };
        const payload = new DecryptedPayload(transferPayload);
        return CreateDecryptedItemFromPayload(payload);
    }
}
